import React, { useState } from "react";
import {
  Overlay,
  DialogContainer,
  DialogTitle,
  DialogDescription,
  DialogActions,
  CancelButton,
  ConfirmButton,
} from "./styles";

type Props = {
  open: boolean;
  title: string;
  description: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({
  open,
  title,
  description,
  loading,
  onConfirm,
  onCancel,
}: Props) {
  if (!open) return null;

  return (
    <Overlay>
      <DialogContainer>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>

        <DialogActions>
          <CancelButton onClick={onCancel} disabled={loading}>
            Cancelar
          </CancelButton>

          <ConfirmButton onClick={onConfirm} disabled={loading}>
            {loading ? "Excluindo..." : "Excluir"}
          </ConfirmButton>
        </DialogActions>
      </DialogContainer>
    </Overlay>
  );
}
